/* Native disclosure navigation works without JavaScript; enhance Escape/outside close. */
(() => {
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.tm-disclosure[open]');
    if (open) { open.removeAttribute('open'); open.querySelector('summary')?.focus(); }
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('.tm-disclosure[open]').forEach((details) => {
      if (!details.contains(event.target) || event.target.closest('nav a')) details.removeAttribute('open');
    });
  });
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('.tm-disclosure[open]')) return;
    document.querySelectorAll('.tm-disclosure[open]').forEach((other) => { if (other !== details) other.removeAttribute('open'); });
  }, true);
  window.addEventListener('pageshow', async (event) => {
    if (!event.persisted) return;
    const cart = document.querySelector('.tm-cart');
    if (!cart) return;
    try {
      const response = await fetch(`${cart.getAttribute('href')}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const data = await response.json();
      document.querySelectorAll('[data-tm-cart-count]').forEach((node) => { node.textContent = String(data.item_count); });
    } catch (_) { /* Keep the server-rendered count if the refresh is unavailable. */ }
  });
})();
